import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "store";
import App from "components/App";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "./styles/blueprint.scss";
import "./styles/index.scss";
import "./styles/global.scss";
const rootEl = document.getElementById("root");
if (!rootEl)
    throw new Error("Root element not found");
const root = ReactDOM.createRoot(rootEl);
const renderApp = () => {
    root.render(React.createElement(React.StrictMode, null,
        React.createElement(Provider, { store: store },
            React.createElement(App, null))));
};
renderApp();
if (module.hot) {
    module.hot.accept("./components/App", () => {
        renderApp();
    });
}
